import { createStyles, rem } from '@mantine/styles';

export default createStyles(() => ({
  dropdown: {},

  itemsWrapper: {
    padding: rem(4),
    display: 'flex',
    width: '100%',
    boxSizing: 'border-box',
  },
}));
